import { FC } from 'react';
import type { AccordionTitleProps } from '../../Accordion.types';
import styles from './AccordionTitle.module.css';
import { Flex } from '@/_components';
import { getClasses } from '@/_utils/classnames';

export const AccordionTitle: FC<AccordionTitleProps> = ({
  children,
  isOpen,
  onClick,
}) => (
  <Flex
    padding={8}
    className={getClasses(styles.title, { [styles.titleOpen]: isOpen })}
    isYCentered={true}
    isBetween={true}
    onClick={onClick}
    backgroundColor="primary"
  >
    {children}
  </Flex>
);
